import axios from 'axios'

/**
 * @desc fetch suppliers for authenticated user
 */
export const fetchSuppliers = () =>
  axios.get('/authenticated/suppliers').then((res) => res.data)
